<template>
  <div>
    <PopupScroll :tap-close="onTapCloseButton" :title="'施設Suggestion'">
      <div class="top-contents">
        <div class="top-contents-img">
          <img src="~@/assets/img/trainers/2_2.jpg" />
        </div>

        <div class="top-contents-bottom">
          <div class="name-wrap">
            <div>
              <p class="des">トレーナー</p>
              <p class="name">T<span class="text-gold">O</span>RA</p>
              <p class="name-kana">トラ</p>
            </div>

          </div>


          <p class="des2">
            主に筋トレメインのトレーナーです。<br>
            ボディメイクや食事など詳しく教えてくれます！
          </p>

          <div class="class">
            <p class="class-title">担当クラス</p>
            <ul style="font-size: 1.4rem;">
              <li>
                ボディメイククラス
              </li>
              <li>
                ファットバーンクラス
              </li>
              <li>
                リズムキック
              </li>
              <li>
                CLUBリズムキック
              </li>
              <li>
                エントリークラス
              </li>
              <li>
                キック初級クラス
              </li>
              <li>
                筋膜リリースクラス
              </li>
            </ul>
          </div>


          <div class="top-contents-bg">
            <img src="~@/assets/img/logo/logo_simple.png" />
          </div>

        </div>


      </div>
      <div class="bottom-contents">


        <div>

          <div class="top-items-title">
            <h2>Message</h2>
            <p>皆様に一言</p>
          </div>
          <p class="bottom-contents-text">
            「格闘技からボディメイクまで運動を通して、<br class="sp-none">皆様のフィットネス生活を充実させていきます。<br>
            一緒に頑張りましょう！」
          </p>



        </div>
        <!-- 
        <div class="bottom-contents-img">
          <img src="~@/assets/img/trainers/2_3.jpg" />
        </div> -->

        <div class="bottom-contents-bg2">
          Make The Body<br />
          You Dream About
        </div>

      </div>



    </PopupScroll>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import dayjs from 'dayjs'
import { PopupScroll } from '@/components/presentational/organisms'
import { useApplicationStore } from '@/store/modules/applicationModule'

export default defineComponent({
  components: {
    PopupScroll,
  },
  setup() {
    const ApplicationStore = useApplicationStore()


    const onTapCloseButton = () => {
      console.log(ApplicationStore);
      
      ApplicationStore.UPD_TOP_PANEL4(false)
    }

   
    return {
      onTapCloseButton,

    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

// override PopupScroll（accountNoteHosp only）
:deep(.popup__box) {
  padding: 22px 0;
}

:deep(.popup__title) {
  padding: 0 30px 0 40px;
}
:deep(.popup__title::before) {
  left: 30px;
}

:deep(.iscroll-wrapper) {
  padding: 0 30px;
}

.accountNoteHospList {
  &__ {
    &inner {
      margin-top: 10px;
      height: 100%;
    }

    &item {
      padding: 15px;
      border: 1px solid #ebebeb;
      border-radius: 6px;
      margin-bottom: 12px;

      &- {
        &bottom {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          border-top: 1px solid #ebebeb;
          padding-top: 7.5px;
        }
      }

      &--disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }

    &product {
      display: flex;
      align-items: center;

      &- {
        &item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          width: 30px;
          height: 15px;
          border: 1px solid;
          border-radius: 4px;
          box-sizing: border-box;
          line-height: 1;
          text-align: center;
          word-break: keep-all;
          margin-right: 6px;
        }

        &text {
          font-size: 1rem;
          transform: scale(0.75);
          transform-origin: center;
          font-weight: bold;
          text-align: center;
        }
      }
    }

    &header-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &start-date {
      & p {
        color: #00000080;
      }
    }

    &text-data {
      padding: 6.5px 10.5px 6.5px 0;

      & p {
        font-size: 1.5rem;
        pointer-events: all;

        & :deep(a) {
          color: rgb(0, 0, 238);
          text-decoration: underline;
        }
      }
    }

    &button-wrapper {
      display: flex;
      align-items: center;

      &--disabled {
        pointer-events: none;
      }



      & li:nth-child(3) {
        margin: 0 14px;
      }
    }

           &button-text {
        margin-right: 5px;
         font-size: 1.076rem;

        &--disabled {
        color: #CFD2D7;
      }

      }

  }
}

.top-contents {
  display: flex;
  font-family: 'Shippori Mincho', serif;


  &-bg {
      opacity: 0.1;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 0;
      width: 50%;
      max-width: 450px;

      & img {
        width: 100%;
      }
    }

    &-bottom {
      position: relative;
      width: 100%;
      margin-left: 5%;

          .des2 {
              font-size: 1.8rem;
              font-family: 'Shippori Mincho', serif;
              letter-spacing: 0.5px;
              margin: 10px 0 20px;
            }
  }

  &-img {
    max-width: 400px;
    width: 100%;
    margin:  0 auto;

    img {
      width: 100%;
    }
  }

  .name {

    &-wrap {

      display: flex;
      justify-content: center;
      border-bottom: 1px solid #c2c3cc; 
      padding-bottom: 20px;

          .des {
              font-size: 2.5rem;
              font-family: 'Shippori Mincho', serif;
              letter-spacing: 0.5px;
              text-align: center;
              margin-bottom: 10px;
            }

    }




    font-size: 6rem;
      font-family: 'Shippori Mincho', serif;
      letter-spacing: 0.5px;
          line-height: 1.1;

      &-kana {
          font-size: 2rem;
            font-family: 'Shippori Mincho', serif;
            letter-spacing: 0.5px;
            text-align: center;
      }

    
  }
  
}

.class {

  &-title {
    font-size: 1.6rem;
    margin-bottom: 10px;
  }

  ul {
    li {
      margin-bottom: 1px;

      &:before {
          display: inline-block;
          vertical-align: middle;
          /*以下白丸つくる*/
          content: '';
          width: .3em;
          height:.3em;
          background: #ada554;
          border-radius: 50%;
          margin-right: 8px;
        }
    }
  }

}

.text-gold {
  color: #ada554;
}

h2 {
      font-size: 1.4rem;
        font-family: 'Shippori Mincho', serif;

        & + p {
          font-size: 2.6rem;
            font-weight: 400;
            margin-bottom: 20px;
            font-family: 'Shippori Mincho', serif;
        }
}


.bottom-contents {
      // background-color: rgba($color: #ada554, $alpha: .2);
      //   position: relative;
      //   padding: 40px 40px 80px;
      //   border-radius: 10px;
      //   margin: 180px auto 80px;
      margin-bottom: 40px;
      margin-top: 40px;
      position: relative;

        &-text {
          font-size: 1.8rem;
            font-weight: 400;
            // margin-bottom: 40px;
            font-family: 'Shippori Mincho', serif;
        }
        

          &-img {
              max-width: 200px;
                position: absolute;
                top: -100px;
                right: 20px;
          
              img {
                width: 100%;
              }
            }

            &-bg2 {
    font-family: 'mafw';
    font-size: 6rem;
    opacity: 0.05;
    position: absolute;
    right: 10%;
    top: 0;
    z-index: 0;
  }
}


@media screen and (max-width: 1200px) {

  .top-contents {

    

      .name {
          font-size: 5.5rem;

          &-wrap {
            .des {
              font-size: 2rem;
            }
          }
        }

  }

    h2+p {
      font-size: 2.6rem;
    }



}

@media screen and (max-width: 1000px) {

.top-contents-bottom .des2 {
  font-size: 1.6rem;
}

.bottom-contents-text {
  font-size: 1.6rem;
}


}

@media screen and (max-width: 768px) {

  .top-contents {
    flex-direction: column;
  }

    .top-contents-bottom {
      margin-left: auto;
      margin-top: 40px;
    }

                        .bottom-contents-bg2 {
              font-size: 3rem;
            }

            .sp-none {
              display: none;
            }

                        .top-contents {
            
            
            
                          .name {
                            font-size: 4rem;
            
                            &-wrap {
                              .des {
                                font-size: 1.8rem;
                              }
                            }
                          }

                          .name-kana {
                            font-size: 1.8rem;
                          }
            
                        }

}

@media screen and (max-width: 350px) {

  .bottom-contents-bg2 {
    font-size: 2.5rem;
  }

}

</style>
